import React, { useState, useEffect } from 'react';
import '../Filter/Filter.css';
import '../../common/CommonText.css';

const GroupBy = ({ options, selectedOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  // If no selectedOption is provided, default to first option
  useEffect(() => {
    if (!selectedOption && options.length > 0) {
      onSelect(options[0]);
    }
  }, []);

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className='filter-container'>
      <div className='filter-text-container'>
        <label className='common-text fts-15 ftw-4 dk-gray'>Group By</label>
      </div>
      <div className="custom-dropdown" onClick={() => setIsOpen(!isOpen)}>
        <div className="selected-option fts-13 lt-gray">
          {selectedOption || options[0]}
          <span className={`filter-dropdown-icon fts-12 ${isOpen ? 'open' : ''}`}>▼</span>
        </div>
        {isOpen && (
          <ul className="options-list">
            {options.map((option, index) => (
              <li
                key={index}
                className={`option-item dk-gray fts-13 ${selectedOption === option ? 'selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOptionClick(option);
                }}
              >
                <span className="check-icon fts-13">
                  {selectedOption === option ? '✔' : ''}
                </span>
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default GroupBy;
